module.exports = __webpack_public_path__ + "img/tab-2.d09df16e.png";